module.exports = __webpack_public_path__ + "0b1d7417bbb52068d4db1f0159ad84cd.png";